import axios from "axios";
import {config} from "../utils/Constants";
import TS from "../utils/TimeStampGenerator";
import { useNavigate } from "react-router-dom";
import useErrorHandler from "../components/ErrorHandler";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import  useDeliveryPickupAxios from "../utils/axios";

// import axios, { axiosPrivate } from "../api/axios";
import { fetchRolesAndPermissions } from "../features/roleAndPermissionsSlice";
import { resetResponseState, setLoading } from "../features/responseSlice";
import jwtDecode from "jwt-decode";
import useRolesAndPermissions from "../api/RolesAndPermissions";


const useGenerateToken = () => {
    const URL = config.url;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ErrorHandler } = useErrorHandler();
    // const { fetchRolesAndPermissions } = useRolesAndPermissions();
    const DeliveryPickupAxios = useDeliveryPickupAxios()

    const generateToken = async (sessionID, timerStatus) => {
      try {
        // Make API call to generate token
        const res = await axios.post(
          `${URL}/Authentication/GenerateToken`,
          { SessionID: sessionID },
          {
            headers: {
              "content-type": "application/json",
            },
          }
        );
    

        const { accessToken } = res.data.payload;

        sessionStorage.setItem("Token", accessToken);

        const decodedToken = jwtDecode(accessToken);
    
        const role = sessionStorage.getItem("Role");
    
        const features = sessionStorage.getItem("Features");
        const parsedFeatures = features ? JSON.parse(features) : [];
    
        const firstFeature = parsedFeatures.find(
          (feature) => feature.features.length > 0
        );
    
        let redirectSlug = "overview"; 
    
        if (role === "Arz") {
          redirectSlug = firstFeature?.features[0]?.slug || "overview";
        } else if (role === "Employee") {
          redirectSlug = firstFeature?.features[2]?.slug || "todo";
        }

        navigate(`/${redirectSlug}`, { replace: true });
      } catch (error) {
        clearInterval(timerStatus);
        ErrorHandler(error);
        throw error;
      }
    };
    

    const RefreshAccessToken = async (refreshToken) => {
      const sessionID = sessionStorage.getItem('SessionID');
      return DeliveryPickupAxios.post(
        `${URL}/Authentication/RefreshToken`,
        {
          refreshToken: refreshToken
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-SESSION-ID': sessionID
          },

        }
      )
        .then((res) => {
          // Store the new access token in sessionStorage
         const token = sessionStorage.setItem("Token", res.data.payload.accessToken);
          


        })
        .catch((error) => {

          sessionStorage.clear();
          dispatch(resetResponseState());
          toast.error("Your session has expired. Please login again.");
          navigate("/", { replace: true });
          throw error;
          
        });
    };
    
    
    


    return {
        generateToken,
        RefreshAccessToken
    }
}



export default useGenerateToken;